import { useCallback } from 'react'
import { useStyles } from './styles'
import { Button, Text, getTheme, useMediaQuery } from '@conexasaude/conexa-hero'

import { BackStepper } from '../BackStepper'
import { IMainLayout } from './types'
import { useFirebaseContext } from '@/modules/Firebase/contexts/FirebaseContext'
import { openWhatsappSupport } from '@/utils/openWhatsappSupport'
import Icon from '@/components/RebrandedHeroIcons'
import TimeZoneLuxon from '@/components/TimeZoneLuxon'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'
import { MobileHeader } from '../MobileHeader'
import { RenderIf } from '@/components/RenderIf'

export const MainLayout: React.FunctionComponent<IMainLayout> = props => {
  const {
    children,
    disabledNextButton,
    actionNextButton,
    variantNextButton,
    variantLinkButton,
    isLoading,
    labelNextButton,
    labelLinkButton,
    actionLinkButton,
    actionBackStepper,
    hideSupportButton,
    hideMobileHeader,
  } = props
  const styles = useStyles()
  const theme = getTheme()

  const { logAnalyticsEvent } = useFirebaseContext()

  const handleBackStepper = useCallback(() => {
    logAnalyticsEvent('Pac_AtivacaoLogada_Voltar')
    actionBackStepper()
  }, [actionBackStepper, logAnalyticsEvent])

  const isMobile = useMediaQuery(`(max-width: ${theme.grid.breakpoint.sm})`)
  const isTablet = useMediaQuery(`(min-width: ${theme.grid.breakpoint.lg})`)

  const openSupportAndSendEvents = () => {
    logAnalyticsEvent('Pac_AtivacaoLogada_ConversarSuporte')
    openWhatsappSupport()
  }

  return (
    <HeroWrapper>
      <div css={styles.layoutContainer}>
        <RenderIf condition={!isMobile}>
          <div css={styles.containerBackground}>
            <div css={styles.backgroundContentContainer}>
              <div css={styles.backgroundNoise} />
              <Icon
                name="character-media-player"
                css={styles.backgroundContainerIcon}
                width={isTablet ? '560px' : '80%'}
              />
              <Text
                variant="headingXLarge"
                color={theme.colors.background.white}
                css={styles.backgroundContainerTitle}
              >
                Olá, nós somos a Conexa Saúde
              </Text>
              <Text
                variant="headingMedium"
                color={theme.colors.background.white}
                css={styles.backgroundContainerSubtitle}
              >
                Seu novo jeito de cuidar da saúde
              </Text>
            </div>
          </div>
        </RenderIf>
        <RenderIf condition={isMobile && !hideMobileHeader}>
          <MobileHeader />
        </RenderIf>
        <div css={styles.body}>
          <div css={styles.contentHeader}>
            <div css={styles.stepperArea}>
              {actionBackStepper && (
                <BackStepper
                  onActionClick={handleBackStepper}
                  color={theme.colors.neutral[200]}
                />
              )}
            </div>
          </div>
          <div css={styles.contentWrapper}>
            <div css={styles.mainCard}>
              <div css={styles.childrenContainer}>{children}</div>
            </div>
          </div>
          <div css={styles.contentFooter}>
            <div css={styles.buttonWrapper}>
              <RenderIf condition={!!actionNextButton}>
                <Button
                  disabled={disabledNextButton}
                  onClick={actionNextButton}
                  variant={variantNextButton}
                  busy={isLoading}
                  fullWidth
                >
                  {labelNextButton}
                </Button>
                <RenderIf condition={!!labelLinkButton}>
                  <Button
                    variant={variantLinkButton || 'secondary'}
                    fullWidth
                    onClick={actionLinkButton}
                  >
                    {labelLinkButton}
                  </Button>
                </RenderIf>
              </RenderIf>
            </div>
            <RenderIf condition={!hideSupportButton}>
              <Text
                variant="linkUnderline"
                onClick={openSupportAndSendEvents}
                css={styles.supportLink}
              >
                Conversar com o Suporte
              </Text>
            </RenderIf>
            <div>
              <TimeZoneLuxon />
            </div>
            <Text
              css={styles.allRightsReserved}
              renderAs="span"
              variant="microCopy"
            >
              © 2021 Conexa Saúde · Todos os direitos reservados.
            </Text>
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}
